<template>
    <div>
        <button v-status="meta.permission_prefix + 'edit'"
            class="btn btn-edit btn-sm" @click="actions(data , 'edit')">
        <i class="fa fa-pencil-alt"></i>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            meta: {
                type: Object,
            },
            actions: {
                typo: Function,
            },
            data:{}
        }
    }
</script>
